import { entity, persistence } from "simpler-state";

interface SplitPreferences {
  additionalFieldsOpenByDefault: boolean;
}

const INITIAL_PREFERENCES: SplitPreferences = {
  additionalFieldsOpenByDefault: false,
};

export const SplitPreferencesState = entity<SplitPreferences>(
  INITIAL_PREFERENCES,
  [persistence("split_preferences")]
);

export function setAdditionalFieldsOpenByDefault(value: boolean) {
  SplitPreferencesState.set((prev) => ({
    ...prev,
    additionalFieldsOpenByDefault: value,
  }));
}

